/** @format */

import {PluginKind} from '@src/types/Plugin'
import {ValueOf} from '@src/typeUtils'

export type FieldValidation = ValueOf<FieldValidationByType>

export function isFieldValidationType<T extends keyof FieldValidationByType>(
  type: T,
  validation: FieldValidation,
): validation is FieldValidationByType[T] {
  return validation.type.value === type
}

export type FieldValidationByType = {
  [K in keyof FieldValidationByTypeSpec]: MapFieldValidationValue<
    FieldValidationByTypeSpec[K]
  >
}

type FieldValidationByTypeSpec = {
  text: {
    type: 'text'
    required?: boolean
    maxlength?: number
  }

  numeric: {
    type: 'numeric'
    required?: boolean
    max?: number
    min?: number
  }

  email: {
    type: 'email'
    required?: boolean
  }

  url: {
    type: 'url'
    required?: boolean
  }

  'datetime-local': {
    type: 'datetime-local'
    required?: boolean
    max?: string
    min?: string
  }

  file: {
    type: 'file'
    required?: boolean
    accept?: string[]
  }
}

type MapFieldValidationValue<T extends ValueOf<FieldValidationByTypeSpec>> = {
  fieldName: string
  // an aggregated set of actions that add any of the validation rules to this field.
  plugins?: Set<PluginKind>
} & {
  [K in keyof T]: T[K] extends undefined
    ? undefined
    : {
        value: NonNullable<T[K]>
        plugins?: Set<PluginKind>
      }
}
